import { FulfillmentGroupData } from "@redotech/redo-model/fulfillments/fulfillment-group";
import {
  getAllShipmentFlags,
  RateForFlag,
  ShipmentFlag,
} from "@redotech/redo-model/outbound-labels/shipment-flag";
import { Team } from "@redotech/redo-model/team";
import { useMemo } from "react";

export function useShipmentFlags(
  fulfillmentGroups: readonly FulfillmentGroupData[],
  selectedRate: RateForFlag | null,
  team: Team | null | undefined,
  fulfillmentDate: Date | null,
): readonly ShipmentFlag[] {
  return useMemo(() => {
    const allFlags = getAllShipmentFlags();
    return allFlags.filter((flag) =>
      fulfillmentGroups.some((fulfillmentGroup) =>
        flag.shouldDisplay({
          selectedRate,
          fulfillmentGroup,
          team,
          fulfillmentDate,
        }),
      ),
    );
  }, [selectedRate, fulfillmentGroups, team, fulfillmentDate]);
}
